import { CruiseActionEnum, SetCabinAction } from '../../consts/actionTypes';

export const CruisePageActionCreators = {
    setCabin: (cabinId: number): SetCabinAction => ({
        type: CruiseActionEnum.SET_CABIN,
        payload: cabinId,
    }),
};
